import React from 'react'

export default function Heart({ className }) {
  return (
    <svg viewBox="0 0 18 15" className={className}>
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M17.677 3.742C17.324 1.955 15.85.528 14.065.24a4.401 4.401 0 00-4.286 1.75.6.6 0 01-.985 0A4.401 4.401 0 004.508.24C2.723.528 1.248 1.955.896 3.742a4.573 4.573 0 00.001 1.81c.894 4.746 8.364 9.418 8.364 9.418s7.521-4.672 8.415-9.418a4.573 4.573 0 00.001-1.81z"
      />
    </svg>
  )
}
